/**
 * Workaround to trigger autoplay.
 */
const handleVideoLoaded = function() {
    const originalMutedState = this.muted;

    if (this.autoplay && this.paused) {
        if (!this.muted) {
            this.muted = true;
        }

        this.play();
        this.muted = originalMutedState;
    }
}

/**
 * @type {NodeListOf<HTMLVideoElement>}
 */
let videos = document.querySelectorAll('.custom-video video');
if (videos.length) {
    videos.addEventListener('loadeddata', handleVideoLoaded);
}
